import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule }  from '@angular/platform-browser';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { UIRouterModule ,UrlService} from '@uirouter/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceModule } from './services/service.module';
import { EdlComplyStates } from './edl-comply.states';
import { EdlComplyComponent } from './edl-comply.component';
import { LayoutModule } from './layout/layout.module';
import { LoginModule } from './login/login.module';
import {LaddaModule} from 'angular2-ladda';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import {RegistrationModule} from './registration/registration.module';
import {PrintModule} from './print/print.module';
import isEqual from 'lodash-es/isEqual';
import { ComponentModule } from './components/components.module';
import { ToastrModule } from 'ngx-toastr';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LocalStorageModule } from 'angular-2-local-storage';
import { environment } from 'src/environments/environment';
import { JwtModule } from '@auth0/angular-jwt';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APPLICATION_TYPE, ApplicationTypes, BannerModule, BASE_URL, BUILD_CREATION_TIMESTAMP, BUILD_VERSION_NUMBER, COMMON_URL, DateInterceptor, FingerprintingInterceptor, EdlCommonComponentsModule, EdlCommonServicesModule, EdlPageComponentsModule, ErrorMessageHelpersService, GlobalComplyErrorHandler, HttpErrorHandler, PagedResponseInterceptor, SessionService } from '@edl-development/edl-common';
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { VERSION } from './version';

export function JwtModuleConfigFactory() {
    const token = localStorage.getItem('edl-comply.token');
    const parsed = JSON.parse(token);

    return parsed;
}

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        BsDatepickerModule.forRoot(),
        LocalStorageModule.forRoot({
            prefix: 'edl-comply',
            storageType: 'localStorage'
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter: JwtModuleConfigFactory,
                allowedDomains: [environment.BASEDOMAIN]
            },
        }),
        NgbModule,
        UIRouterModule.forRoot({
            states: EdlComplyStates,
            otherwise: {
                state: 'public.page-not-found',
                params: {}
            },
            useHash: false
        }),
        ServiceModule,
        LayoutModule,
        LoginModule,
        RegistrationModule,
        PrintModule,
        BrowserAnimationsModule,
        ComponentModule,
        EdlCommonComponentsModule,
        EdlCommonServicesModule,
        EdlPageComponentsModule,
        LaddaModule.forRoot({
            style: 'zoom-in'
        }),
        ToastrModule.forRoot(),
        BannerModule,
        LoadingBarModule,
        ErrorTailorModule.forRoot({
            errors: {
              useFactory(service: ErrorMessageHelpersService) {
                return service.generateErrorMap();
              },
              deps: [ErrorMessageHelpersService]
            }
          })
    ],
    declarations: [
        EdlComplyComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorHandler, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: FingerprintingInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: PagedResponseInterceptor, multi: true },
        { provide: APPLICATION_TYPE, useValue: ApplicationTypes.EDL_COMPLY },
        { provide: COMMON_URL, useValue: `${environment.BASEURI}/common` },
        { provide: BASE_URL, useValue: `${environment.BASEURI}/comply` },
        { provide: BUILD_VERSION_NUMBER, useValue: VERSION.version },
        { provide: BUILD_CREATION_TIMESTAMP, useValue: VERSION.timestamp },
        {
            provide: ErrorHandler, 
            useClass: GlobalComplyErrorHandler
        }
    ],
    bootstrap: [
        EdlComplyComponent
    ]
})

export class EdlComplyModule {
    constructor(
        private sessionService: SessionService,
        private urlService: UrlService
    ) {
        if (this.sessionService.isRestorable()) {
            this.sessionService.restore();
        }

        urlService.config.type('myjson', {
            encode: (obj) => JSON.stringify(obj),
            decode: (str) => JSON.parse(str),
            is: (val) => typeof(val) === 'object',
            pattern: /[^/]+/,
            equals: (a, b) => isEqual(a, b),
          });
          

        this.urlService.config.type('searchBy', {
            encode: (obj) => {
                return obj;
            },
            decode: (obj) => {
                return decodeURIComponent(obj);
            },
            is: (val) => {
                return typeof val === 'string';
            },
            pattern: /[^/]*/,
            equals: (a, b) =>  isEqual(a, b),
            
        });
    }
}

